import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from 'app/core/auth.service';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Client } from 'app/interfaces/client.interface';

@Injectable({
    providedIn: 'root'
})
export class ClientManagementService {
    constructor(private authService: AuthService, private firestore: AngularFirestore) {
        console.debug('ClientManagementService: instantiated');
    }

    watchResourceManagementObjects(): Observable<Client[]> {
        const collection = this.firestore.collection<Client>('clients');

        return collection.snapshotChanges().pipe(
            map(actions => {
                return actions.map(action => {
                        const data = action.payload.doc.data() as Client;

                        return { action : action.type.toString(), ...data };
                    });
            })
        );
    }

    watchResourceManagementObject(key: string): Observable<Client> {
        const docRef = this.firestore.collection('clients').doc<Client>(key);
    
        return docRef.snapshotChanges().pipe(
            map(action => {
                const data = action.payload.data() as Client;

                return { action: action.type.toString(), ...data };
            })
        );
    }

    // Fetch all clients
    async getAllResourceManagementObjects(): Promise<Client[]> {
        try {
            const clientsSnapshot = await this.firestore.collection<Client>('clients')
                .get()
                .toPromise();

            const clients: Client[] = clientsSnapshot.docs.map(doc => doc.data() as Client);

            var sortedArray: Client[] = clients.sort((n1,n2) => {
                if (n1.name > n2.name) {
                    return 1;
                }
                if (n1.name < n2.name) {
                    return -1;
                }
                return 0;
            });

            return sortedArray;
        }
        catch (error) {
            console.error('Error fetching all clients:', error);
            throw error;
        }
    }

    // Fetch specific client by its key
    async getResourceManagementObject(key: string): Promise<Client> {
        try {
            const client = await this.firestore.doc<Client>(`clients/${key}`)
                .valueChanges()
                .toPromise();

            return client;
        }
        catch (error) {
            console.error(`Error fetching client with key ${key}:`, error);
            throw error;
        }
    }
}
